import { Component, ViewEncapsulation, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DocumentMedialDataModel, DocumentMediaModel, Util } from '@phdsoft/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TemplateService } from '../../template.service';
import { IWindow } from '@phdsoft/window';
import { ModalConfirmComponent } from '@phdsoft/modal-confirm';
import { DocumentsListService } from '../documents-list/documents-list.service';
import { AnomalyService } from 'src/app/admin/services/anomaly.service';
import { PhotoService } from '@app/shared/services/media-services/photo.service';
import { OfflinePhotoService } from '@app/shared/services/media-services/offline-photo.service';
@Component({
  selector: 'phdsoft-documents-modal',
  templateUrl: './documents-modal.component.html',
  styleUrls: ['./documents-modal.component.scss'],
})
export class DocumentsModalComponent implements AfterViewInit {
  public typeFile: string;
  public urlSafe: SafeResourceUrl;
  public loading = true;
  public embed: boolean;
  public video: boolean;
  public image: boolean;
  public iframe: boolean;
  public embedWidth: string;
  public title: string;
  public anomalyId: string;

  @ViewChild('draggable') draggableElement: ElementRef;


  optionsWindow: IWindow = {
    Position: 'center',
    PositionMini: '',
    VisibleMini: false,
    PanelClass: 'modalClass',
    Header: {
      Icon: 'info',
      VisibleTitle: true,
      Title: '',
      Visible: true
    },
    Footer: {
      Visible: true,
      ShowOk: false,
      ShowCancel: false
    }
  };

  constructor(
    private dialogRef: MatDialogRef<DocumentsModalComponent>,
    private sanitizer: DomSanitizer,
    private templateService: TemplateService,
    private readonly dialog: MatDialog,
    private documentsListService: DocumentsListService,
    private anomalyService: AnomalyService,
    @Inject(MAT_DIALOG_DATA) private data: DocumentMedialDataModel,
    private photoService: PhotoService,
    private offlinePhotoService: OfflinePhotoService
  ) { }

  async ngAfterViewInit(): Promise<void> {
    const docType = this.getDocType();

    if(window.navigator.onLine && !this.data.document.offlineImageUrl){
      this.embedWidth = `${(window.window.innerWidth - (window.window.innerWidth * .5))}`;

      var link
      if (this.data.document.BlobPath) {
       link = this.data.document.BlobPath;
      } else {
        link = this.data.document.secureUrl
      }
      if (!link.includes('https://phdc4dtest.blob.core.windows.net/phdsoft/') && (!link.includes('https://phdc4d') && !link.includes('.blob.core.windows.net/'))) {
        const blobValue = 'https://phdc4dtest.blob.core.windows.net/phdsoft/' + link;
        link = blobValue;
      }

      switch (docType) {
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
          this.templateService.loading = true;
          link = `https://docs.google.com/gview?url=${link}&embedded=true`;
          this.typeFile = 'application/pdf';
          this.iframe = true;
          break;
          case 'pdf':
            this.templateService.loading = true;
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            link = isMobile ? `https://docs.google.com/gview?url=${encodeURIComponent(link)}&embedded=true` : link;
            this.typeFile = 'application/pdf';
            this.iframe = true;
            break;
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'bmp':
          this.typeFile = `image/${docType}`;
          this.image = true;
          break;
        case 'mp4':
          this.typeFile = 'video/mp4';
          this.video = true;
          break;
        case 'avi':
          this.typeFile = 'video/x-msvideo';
          this.video = true;
          break;
        case 'youtube':
          this.iframe = true;
          link = Util.youtubeRegex(link);
          break;
        default:
          window.open(link, '_blank');
          this.dialogRef.close(false);
          return void 0;
      }
      this.title = this.data.document.Label;
      this.optionsWindow.Header.Title = this.title;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }

    if(!window.navigator.onLine || this.data.document.offlineImageUrl) {
      this.typeFile = `image/${docType}`;
      this.urlSafe = this.data.document.offlineImageUrl;
      this.image = true;
    }

    setTimeout(() => this.templateService.loading = false, 300);
    this.loading = false;
  }

  private getDocType(): string {
    let docType = this.data.document.DocumentType;
    const YOUTUBE = this.data.document.BlobPath?.toLowerCase().includes('youtu');

    if (this.data.document.DocumentType === 'LINK' && !YOUTUBE) {
      docType = this.data.document.BlobPath.split('.').pop();
    }

    if (YOUTUBE) {
      docType = 'YOUTUBE';
    }

    docType = docType.toLowerCase().replace('.', '')

    return docType;
  }

  questionDeleteDocument(): void {

    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: 'Confirm delete',
        question: `Delete this item?`,
        // item: this.form.get('ELementLabel')?.value,
        // confirmButtonText: `Confirm`,
        // cancelButtonText: `Cancel`,
      },
      hasBackdrop: true,
      panelClass: 'transparentModal',
    });
    dialogRef.afterClosed().subscribe(async (data) => {

      if (data?.result) {
        let returnedValue: any = null;
        if (this.data.document.isNewPhotoImplementation) {
          if (window.navigator.onLine) {
            await this.photoService.deletePhoto(this.data.document.id).toPromise();
          } else {
            await this.offlinePhotoService.deleteOfflinePhoto(this.data.document.id);
          }

          returnedValue = true;
        } else {
          returnedValue = await this.documentsListService.deleteImage(this.data.document.Id ? this.data.document.Id : this.data.document.id) as any;
        }

        if (returnedValue === 'true' || returnedValue == true) {
          if (this.data.css) {
            const parent = this.data.css.parent;
            parent.remove(this.data.css);
          }
          this.dialogRef.close(this.data?.document?.id)
          // this.dialog.closeAll();

          if (this.data.css?.userData?.AfterDeletion) {
            this.data.css?.userData?.AfterDeletion();
          }
        }
      }
    });
  }
}
